import { Head, Link } from "@inertiajs/react"
import { ChevronLeft } from "lucide-react"
import { AppShell } from "@/components/AppShell"
import { PageHeader } from "@/components/PageHeader"
import { SettingsSubNav } from "../SettingsSubNav"
import { ChannelForm, ChannelData } from "./ChannelForm"

export default function ChannelsNew({ channel }: { channel: ChannelData }) {
  return (
    <>
      <Head title="New channel">
        <meta name="description" content="Add a new channel to SparkDrop." />
        <meta property="og:title" content="New channel" />
        <meta property="og:description" content="Add a new channel to SparkDrop." />
      </Head>
      <AppShell>
        <PageHeader
          title="Settings"
          description="Configure how SparkDrop talks to the world."
          tabs={<SettingsSubNav active="channels" />}
        />

        <Link
          href="/settings/channels"
          className="mt-6 inline-flex items-center gap-1 text-sm text-ink-muted hover:text-ink-display"
        >
          <ChevronLeft className="h-3 w-3" /> All channels
        </Link>

        <h2 className="mt-3 text-base font-semibold">New channel</h2>

        <div className="mt-6">
          <ChannelForm channel={channel} mode="new" />
        </div>
      </AppShell>
    </>
  )
}
